import BankNoteIcon from "@redotech/redo-icons/bank-note-01.svg";
import { NumberFilterOperator } from "@redotech/redo-model/views/advanced-filters/number-filter";
import { fgFilterEntries } from "@redotech/redo-model/views/fulfillment/fg-filter-catalog";
import { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.totalPrice;

export const TotalPriceFilter: AdvancedTableFilter = {
  type: entry.type,
  Icon: BankNoteIcon,
  min: 0,
  step: 0.01,
  prefix: "$",
  data: {
    name: entry.name,
    type: entry.type,
    value: null,
    operator: NumberFilterOperator.GREATER_THAN,
  },
  displayName: entry.displayName,
};
